import { Sum } from 'src/app/shared/utilities';
import { ChineseReceiptInfo } from './../../../services/api-service/hist/whole-large-hist';
import { Hist } from "src/app/hist/models/hist";
import { WholeHist, WholeHistPatientsDto, WholeHistRegisterDto } from "src/app/services/api-service/hist/whole-hist";
import { CmsReportAdditionalParamter, DrugBagInfo, ReceiptInfoDto } from "src/app/services/api-service/hist/whole-large-hist";
import { NHIRegIC } from "src/app/services/api-service/register/nhiRegIc";
import { Rx } from "src/app/services/api-service/rx/rx";
import { Clinic } from "../../clinic/models/clinic";
import { UserCache } from "src/app/services/user-cache";
import { ValueTextPair } from "src/app/shared/models/value-text-pair";
import { ReceiptOwnFees } from "../components/receipt/receipt.component";
import { PRN001Params } from "src/app/services/api-service/parameters/PRN001Params";

import { CidMaskPipe } from "src/app/shared/pipes/cid-mask.pipe";
import { DateHelper } from "src/app/shared/helpers/date-helper";
import { RHDesc, RHEnum } from "src/app/enums/RHEnum";
import { BloodDesc, BloodEnum } from "src/app/enums/BloodEnum";
import { ClinicTypeDesc } from "src/app/enums/ClinicTypeEnum";
import { NHILevelDesc } from "src/app/enums/NHILevelEnum";
import { MedicalDesc } from "src/app/enums/MedicalEnum";
import { ValueTextPairBundle } from "src/app/services/data-service/clinic-data-service";
import { HistEditOption } from "src/app/services/api-service/hist/hist-edit-option";
import { RegistEditOpt } from "src/app/services/api-service/register/register-api";
import { HistOrder } from "src/app/hist/models/hist-order";
import { AgePipe } from "src/app/shared/pipes/age.pipe";
import { FormatRocDatePipe } from "src/app/shared/pipes/format-date-roc.pipe";
import { VitalSign } from "src/app/services/api-service/hist/vital-sign";
import { Hspid } from "src/app/services/api-service/hspid/hspid";
import { OrderTypeEnum } from "src/app/enums/OrderTypeEnum";
import { OrderSpecialRuleEnum } from "src/app/enums/OrderSpecialRuleEnum";
import { RegisterConst } from "src/app/shared/constants/register-const";

export interface ICmsRecipt {
  style?: cmsReciptStyle;
}

/**
 * 送印邊界，輸出為 @page 的 margin。
 * 用途是避開印表機的實體不可印區：邊界為 0 時內容貼齊紙緣，落在不可印區內的整行不會印出。
 * 邊界同時決定可印高度，內容超出時列印引擎才會換頁，而非壓縮字距塞進單頁。
 * enabled 為 false 時一律輸出 0cm，與未設定邊界的版面行為相同。
 * 四個值皆為 CSS 長度字串（如 '0.5cm'）。
 */
export class CmsPrintMargin {
  enabled: boolean = false;
  top: string = '0cm';
  right: string = '0cm';
  bottom: string = '0cm';
  left: string = '0cm';
}

/**
 * 補上邊界設定。設定畫面以 printMargin 的存在與否決定欄位是否可綁定，
 * 而早於此功能建立的版面其 JSON 沒有這個欄位，載入後須先補值。
 */
export function ensureCmsPrintMargin<T extends { printMargin?: CmsPrintMargin }>(v: T): T {
  if (v && !v.printMargin) {
    v.printMargin = new CmsPrintMargin();
  }
  return v;
}

/** 取得 @page 可用的 margin 值；未啟用或未設定時為 0cm。 */
export function cmsMarginCss(m: CmsPrintMargin): string {
  if (!m || !m.enabled) {
    return '0cm';
  }
  const v = (x: string) => (x && x.trim()) ? x.trim() : '0cm';
  return `${v(m.top)} ${v(m.right)} ${v(m.bottom)} ${v(m.left)}`;
}

export class cmsRecipt implements ICmsRecipt {
  code: string;
  pwd?: string;
  width: string;
  height: string;
  isHelf: boolean;
  style?: cmsReciptStyle;
  /** 醫令前 */
  rowsBeforeRx: cmsReceiptRow[];
  /** 醫令設定 */
  rowsOfRx: cmsReceiptRow[];
  /** 醫令後 */
  rowsAfterRx: cmsReceiptRow[];
  /** 醫令清單的高度 */
  hrxHeight?: number;

  hrxWidthRatio?: number;

  /** 醫令規則 */
  hrxRule?: CmsHrxRule[];
  replaceRule?: CmsReplaceRule[];
  /** 送印邊界 */
  printMargin?: CmsPrintMargin;
  /**
   *
   */
  constructor() {
    this.width = '';
    this.height = '';
    this.isHelf = false;
    this.style = null;
    this.rowsBeforeRx = [];
    this.rowsAfterRx = [];
    this.printMargin = new CmsPrintMargin();
  }
}
export class cmsReceiptRow implements ICmsRecipt {
  style?: cmsReciptStyle;
  cols: cmsReceiptCol[];
  /** 自動換行 */
  wrap?: boolean;
  overflowHidden?: boolean;
  spacing?: number;
  constructor() {
    this.cols = []
  }
}
export class cmsReceiptCol implements ICmsRecipt {
  /** 欄位名稱 */
  label: string;
  /** 靜態文字 資料前 */
  textBefore?: string;
  /** 靜態文字 資料後 */
  textAfter?: string;
  /** 資料轉換 */
  mapping?: CmsColDataCalc;
  /** 資料類型 */
  dataSource?: string;
  /** 資料綁定 */
  dataField?: string;
  style?: cmsReciptStyle;
  constructor() {
    this.label = '';
    this.textBefore = '',
      this.textAfter = '';
    this.dataSource = '';
  }
}
export class cmsReciptStyle {
  fontSize?: number;
  fontFamily?: string;
  textAlign?: string;
  padLeft?: number;
  rowHeight?: number;
  hiddenIfEmpty?: boolean;
  width?: number;
  textOverflow?: string;
  multiLine?: boolean;
  valStart?: 'left' | 'right' = 'left';
  valLength?: number;
}

export interface LayoutContent {
  value: string;
  ratio: number;
  firstPageOnly?: boolean; // 只顯示在第一頁
}

export class CmsLayout {
  width: string;
  height: string;
  rows: number;
  cols: number;
  contents: LayoutContent[] | string[];
  /** 勾選後直接使用布局設定的寬高，不取印表機紙張尺寸(GetPaperSize) */
  useCustomSize?: boolean;
  /** 送印邊界。布局的邊界獨立於旗下各區塊，各區塊自帶的 @page 不會進入布局輸出。 */
  printMargin?: CmsPrintMargin;
}
export class CmsHrxRule {
  field: string;
  rule: string;
  values: string;
}
export class CmsReplaceRule {
  source: string;
  field: string;
  rule: string;
  values: string;
  target: string;
  order: number;
}
import { Parser } from 'expr-eval'
import { DosageRemarkModel } from 'src/app/hist/models/dosage-remark-model';
export class CmsColDataCalc {
  Condi: CmsColCondition[];
  Vars: CmsColVariable[];
  static TestCond(condi: CmsColCondition[], num: { [key: string]: string }, ignoreEx: boolean = false) {
    //var n = parseFloat(num);
    var p = new Parser({
      operators: {
        logical: true
      }
    });
    p.functions.str = (...args: any[]) => args.join('');
    p.functions.substr = (str:string,stIndex:number,length:number) => str.substring(stIndex,stIndex+length);
    for (let c of condi) {
      try {
        if (!c.c || !c.v) {
          continue;
        }
        var e = p.parse(c.c)
        var ok = e.evaluate(num)
        if (ok == true) {
          var e2 = p.parse(c.v);
          var val = e2.evaluate(num)
          return val;
        }
      } catch (e) {
        if (ignoreEx) {
          continue;
          console.log('公式錯誤：' + c.c + '=>' + c.v + ' (' + e + ')')
        } else {
          throw ('公式錯誤：' + c.c + '=>' + c.v + ' (' + e + ')')
        }
      }
    }
    return num.x;
  }
}
export class CmsColVariable {
  /** 變數名稱 */
  n: string;
  /** 來源資料集 */
  s: string;
  /** 來源欄位 */
  f: string;
  /** 測試 */
  t?: string;
}
export class CmsColCondition {
  /** 條件 */
  c: string;
  /** 值 */
  v: string

}
export var ReceiptDataSourceClinic: ValueTextPair[] = [
  { text: '客代', value: 'Code' },
  { text: '名稱', value: 'Name' },
  { text: '地址(全)', value: 'Address', extension: (a: ReceiptData, value: any) => a.Clinic.City + a.Clinic.Area + a.Clinic.Street },
  { text: '縣市', value: 'City' },
  { text: '區域', value: 'Area' },
  { text: '街道', value: 'Street' },
  { text: '郵遞區號', value: 'ZipCode' },
  { text: '電話', value: 'Phone' },
  { text: 'E-Mail', value: 'Email' },
  { text: '傳真', value: 'Fax' },
  { text: '醫事機構代碼', value: 'NHICode' },
  { text: '負責人', value: 'OwnerName' },
  { text: '科別', value: 'MedDeptCode' },
  { text: '院所層級', value: 'NHILevel', extension: (a: ReceiptData, value: any) => NHILevelDesc.find(x => x.value == value)?.text ?? '' },
  { text: '特約類別', value: 'NHIType', extension: (a: ReceiptData, value: any) => MedicalDesc.find(x => x.value == value)?.text ?? '' },
  { text: '診所類別', value: 'Type', extension: (a: ReceiptData, value: any) => ClinicTypeDesc.find(x => x.value == value)?.text ?? '' },
]

export var ReceiptDataSourcePatient: ValueTextPair[] = [
  { text: '病歷號', value: 'PatientNo' },
  { text: '診所自訂碼', value: 'Kcstmr' },
  { text: '中文名', value: 'CName' },
  { text: '身分證', value: 'CIdMasked', extension: (a: ReceiptData, value: string) => new CidMaskPipe().transform(a.Patient.CId, a.PRN001.IDHidePRN) },
  { text: '身分證(無碼)', value: 'CId' },
  { text: '生日', value: 'BirthdayMasked', extension: (a: ReceiptData, value: Date) => new FormatRocDatePipe().transform(a.Patient.Birthday, false, a.PRN001.BirthdayHidePRN) },
  { text: '生日(無碼)', value: 'Birthday', extension: (a: ReceiptData, value: Date) => DateHelper.getROCDateString(new Date(value)) },
  { text: '年齡', value: 'Age', extension: (a: ReceiptData, value: Date) => new AgePipe().transform(a.Patient.Birthday) },
  { text: '性別名稱', value: 'SexName' },
  { text: '國籍', value: 'Country' },
  { text: '食物過敏', value: 'FoodAllergy' },
  { text: '藥物過敏', value: 'DrugAllergy' },
  { text: '病史', value: 'DiseaseHistory' },
  { text: '病史註記', value: 'DiseaseHistoryRemark' },
  { text: '註記', value: 'Remark' },
  { text: '電話', value: 'Phone' },
  { text: '電話區碼', value: 'PhoneArea' },
  { text: '手機', value: 'CellPhone' },
  { text: '戶籍地址 郵遞區號', value: 'ResZipCode' },
  { text: '戶籍地址 城市', value: 'ResCity' },
  { text: '戶籍地址 區域', value: 'ResArea' },
  { text: '戶籍地址 街道', value: 'ResStreet' },
  { text: '居住地址 郵遞區號', value: ' ZipCode' },
  { text: '居住地址 城市', value: 'City' },
  { text: '居住地址 區域', value: 'Area' },
  { text: '居住地址 街道', value: 'Street' },
  { text: '保險身份', value: 'ICode' },
  { text: '血型', value: 'BlType', extension: (a: ReceiptData, value: any) => BloodDesc.find(x => x.value == value)?.text ?? '' },
  { text: 'RH值', value: 'BlRH', extension: (a: ReceiptData, value: any) => RHDesc.find(x => x.value == value)?.text ?? '' },
  { text: '職業', value: 'JobCode' },
  { text: '教育程度', value: 'EducationCode' },
]
export var ReceiptDataSourceRegister: ValueTextPair[] = [
  { text: '候診序號', value: 'WaitNo' },
  { text: '看診日期', value: 'RegDate', extension: (a: ReceiptData, value: Date) => DateHelper.getROCDateString(new Date(value)) },
  { text: '看診日期(星期)', value: 'RegDateWeekDay', extension: (a: ReceiptData, value: Date) => DateHelper.getWeekOfDayText(new Date(a.Register.RegDate)).replace('周', '') },

  { text: '報到日期時間', value: 'CheckinTime', extension: (a: ReceiptData, value: any) => (DateHelper.formatROCDateTime(value) + ' ' + DateHelper.getHourMinTime(value, true)) },
  { text: '報到日期(星期)', value: 'CheckinTimeWeekDay', extension: (a: ReceiptData, value: Date) => DateHelper.getWeekOfDayText(new Date(a.Register.CheckinTime)).replace('周', '') },
  { text: '開始日期時間', value: 'BeginTime', extension: (a: ReceiptData, value: any) => (DateHelper.formatROCDateTime(value) + ' ' + DateHelper.getHourMinTime(value, true)) },
  { text: '完診日期時間', value: 'EndTime', extension: (a: ReceiptData, value: any) => (DateHelper.formatROCDateTime(value) + ' ' + DateHelper.getHourMinTime(value, true)) },
  // {text:'報到日期時間',value:'CheckinTime',extension:(a:ReceiptData,value:Date)=>DateHelper.formatROCDateTime(value)},
  // {text:'開始日期時間',value:'BeginTime',extension:(a:ReceiptData,value:Date)=>DateHelper.formatROCDateTime(value)},
  // {text:'完診日期時間',value:'EndTime',extension:(a:ReceiptData,value:Date)=>DateHelper.formatROCDateTime(value)},
  { text: '保險身分', value: 'ICodeName' },
  { text: '收案別', value: 'ClassName' },
  { text: '科別', value: 'MedDeptCode' },
  { text: '科別名稱', value: 'MedDeptName', extension: (a: ReceiptData, value: string) => a.regOptions.section.find(x => x.value == a.Register.MedDeptCode)?.text || value },
  { text: '就診狀態名稱', value: 'StatusName' },
  { text: '就醫憑證', value: 'ITyp' },
  { text: '同一療程', value: 'SameTreat' },
  {
    text: '醫師身分證', value: 'DoctorCIdMasked',
    extension: (a: ReceiptData, value: string) => new CidMaskPipe().transform(a.Register.DoctorCId, a.PRN001.IDHidePRN)
  },
  { text: '醫師身分證(無碼)', value: 'DoctorCId' },
  { text: '醫師名稱', value: 'DoctorName' },
  { text: '管制藥品使用執照號碼', value: 'DrugControlNo' },
  { text: '健保就醫類別', value: 'Nhict' },
  { text: '健保卡年度', value: 'Nhiyear' },
  { text: '就醫序號', value: 'Icno' },
  { text: '診間名稱', value: 'RoomName' },
  { text: '時段別', value: 'TimeSecName' },
  { text: '付款狀態', value: 'PaymentStatusName' },
  { text: '備註', value: 'Remark' },
  { text: '就診來源 名', value: 'VisitTypeName' },
  { text: '掛號來源名稱', value: 'RegSourceName' },
  { text: '欠卡日期', value: 'LackCardDate', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '還卡日期', value: 'ReCardDate', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '折扣代碼', value: 'DiscountCode' },
  { text: '自費額', value: 'OwnFee' },
  { text: '掛號', value: 'RegisterFee' },
  { text: '押金', value: 'LAMT' },
  { text: '轉診來源機構代碼', value: 'OriHosp' },
  { text: '轉診來源機構名稱', value: 'OriHospName', extension: (a: ReceiptData, value: any) => a.Hspids?.find(x => x.HID === a.Register.OriHosp)?.HNAME ?? '' },
  { text: '下次預約日期時間', value: 'NextAppointment', extension: (a: ReceiptData, value: Date) => (value ? (DateHelper.formatROCDateTime(value) + '(' + DateHelper.getWeekOfDayText(new Date(value)).replace('周', '') + ') ' + DateHelper.getHourMinTime(value, true)) : '') },
  { text: '掛號序號', value: 'RegSerialNumber' },
  { text: '收據序號', value: 'ReceiptSerialNumber' },
]

export var ReceiptDataSourceHist: ValueTextPair[] = [
  { text: '主訴', value: 'CC' },
  { text: '理學', value: 'PE' },
  { text: '主診斷', value: 'Dx1' },
  { text: '主診斷名', value: 'Dx1Name' },
  { text: '次診斷', value: 'Dx2' },
  { text: '次診斷名', value: 'Dx2Name' },
  { text: '診斷3', value: 'Dx3' },
  { text: '次診斷名3', value: 'Dx3Name' },
  { text: '診斷4', value: 'Dx4' },
  { text: '次診斷名4', value: 'Dx4Name' },
  { text: '診斷5', value: 'Dx5' },
  { text: '次診斷名5', value: 'Dx5Name' },
  { text: '診斷6', value: 'Dx6' },
  { text: '次診斷名6', value: 'Dx6Name' },
  { text: '主手術', value: 'Sur1' },
  { text: '主手術名', value: 'SurName' },
  { text: '次手術1', value: 'Sur2' },
  { text: '次手術2', value: 'Sur3' },
  { text: '藥師身分證(無碼)', value: 'PharmacistCId' },
  {
    text: '藥師身分證', value: 'PharmacistCIdMasked',
    extension: (a: ReceiptData, value: string) => new CidMaskPipe().transform(a.Hist.PharmacistCId, a.PRN001.IDHidePRN)
  },
  { text: '藥師姓名', value: 'PharmacistName' },
  { text: '領藥號', value: 'PickUpDrugNo' },
  { text: '醫師身分證(無碼)', value: 'DoctorCId' },
  {
    text: '醫師身分證', value: 'DoctorCIdMasked',
    extension: (a: ReceiptData, value: string) => new CidMaskPipe().transform(a.Hist.DoctorCId, a.PRN001.IDHidePRN)
  },
  { text: '同療程開始日期', value: 'DateStart', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '同療程結束日期', value: 'DateEnd', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '療程類別', value: 'CusTP' },
  { text: '療程次別', value: 'CusNo' },
  { text: '療程總次', value: 'CusTot' },
  { text: '療程分類', value: 'CusCl' },
  {
    text: '健保卡卡序',
    value: 'Isqno',
    extension: (a: ReceiptData, value: any) =>
      a.Register?.SameTreat == RegisterConst.SameTreat_2_預防保健 && value
        ? `IC${value}`
        : value
  },
  { text: '原處方卡序(藥局用)', value: 'IsqnoOrig' },
  { text: '勞保職業傷病', value: 'LABTP' },
  { text: '總申報天數', value: 'Days' },
  { text: '科別', value: 'Dept' },
  { text: '初複', value: 'Emer', extension: (a: ReceiptData, value: any) => value == 0 ? '初診' : '複診' },
  { text: 'T轉入, Y轉出, N非轉', value: 'Referral', extension: (a: ReceiptData, value: any) => value == 'T' ? '轉入' : value == 'Y' ? '轉出' : '非轉' },
  { text: '轉出醫院', value: 'RefHosp' },
  { text: '轉入醫院', value: 'InHosp' },
  { text: '開立處方單位', value: 'RxHosp' },
  { text: '檢驗交付單位', value: 'LabHosp' },
  { text: '給付類別', value: 'PayTP' },
  { text: '特定治療1', value: 'SPTX1' },
  { text: '特定治療2', value: 'SPTX2' },
  { text: '特定治療3', value: 'SPTX3' },
  { text: '特定治療4', value: 'SPTX4' },
  { text: '案件分類', value: 'Case' },
  { text: '調劑方式', value: 'DispTP' },
  { text: '診察費', value: 'ADx' },
  { text: '藥費', value: 'ARx' },
  { text: '內服藥費', value: 'ARx2' },
  { text: '外用藥費', value: 'ARx3' },
  { text: '注射藥費', value: 'ARx4' },
  { text: '診療費', value: 'ATx' },
  { text: '注射技術費', value: 'ATx5' },
  { text: '檢驗費', value: 'ATx6' },
  { text: '放射費', value: 'ATx7' },
  { text: '復健治療費', value: 'ATx8' },
  { text: '處置費', value: 'ATx9' },
  { text: '手術費', value: 'ATx10' },
  { text: '麻醉費', value: 'ATx11' },
  { text: '材料費', value: 'AMat' },
  { text: '輸血費', value: 'ATx13' },
  { text: '透析費', value: 'ATx14' },
  { text: '病房費', value: 'ATx15' },
  { text: '管灌費', value: 'ATx16' },
  { text: '嬰兒費', value: 'ATx17' },
  { text: '藥事費', value: 'AMed' },
  { text: '包裹實批', value: 'APack' },
  { text: '其他費1', value: 'A01' },
  { text: '其他費2', value: 'A02' },
  { text: '健保總額', value: 'ATot' },
  { text: '部份負擔代號', value: 'ApartCode' },
  { text: '部份負擔-藥品', value: 'APartRx', extension: (a: ReceiptData, value: any) => !isNaN(value) ? Math.abs(value) : value },
  { text: '藥局部份負擔-藥品', value: 'PPartRx' },
  { text: '部份負擔-門診', value: 'APartOPD' },
  { text: '部份負擔-檢查', value: 'APartExam' },
  { text: '自費總額', value: 'AOwn' },
  { text: '申請總額(健保總額-部分負擔)', value: 'ADcl' },
  { text: '論件計酬', value: 'Drgs' },
  { text: '慢箋次別', value: 'CntPresNo' },
  { text: '慢箋總次', value: 'CntPresTot' },
  { text: '慢箋開始日', value: 'CntPresDate', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '欠卡讀取的就醫識別碼', value: 'LackTreatnum' },
  { text: '↑讀取時間(欠卡讀取的就醫識別碼)', value: 'LackDate', extension: (a: ReceiptData, value: Date) => DateHelper.formatROCDate(value) },
  { text: '免部分負擔原因', value: 'ApartCodeDescription' },
]
export var ReceiptDataSourceFee: ValueTextPair[] = [
  { text: '自費藥品', value: 'OwnRx' },
  { text: '自費注射', value: 'OwnTx4' },
  { text: '自費注射技術', value: 'OwnTx5' },
  { text: '自費檢驗檢查', value: 'OwnTx67' },
  { text: '自費特殊A30費-點滴費', value: 'OwnTx30' },
  { text: '自費特殊A31費-保健食品', value: 'OwnTx31' },
  { text: '自費特殊A32費-處方藥', value: 'OwnTx32' },
  { text: '自費處置', value: 'OwnTx9' },
  { text: '自費手術', value: 'OwnTx10' },
  { text: '自費麻醉', value: 'OwnTx11' },
  { text: '自費特材', value: 'OwnTx12' },
  { text: '其他自費', value: 'OwnOther' },
  {
    text: '總計', value: 'Total', extension: (a: ReceiptData, value: any) =>
      a.Register.RegisterFee + a.Register.OwnFee + a.Hist.APartExam + (a.Hist.APartRx * -1) + a.Hist.AOwn + a.Register.LAMT
  },
  {
    text: '總計(不含押金)', value: 'TotalNoLamt', extension: (a: ReceiptData, value: any) =>
      a.Register.RegisterFee + a.Register.OwnFee + a.Hist.APartExam + (a.Hist.APartRx * -1) + a.Hist.AOwn
  },
]

/** 醫令可用資料，加工方法在extension設定 (a:ReceiptData,value:any,hrx:HistOrder)=>any */
export var ReceiptDataSourceHRx: ValueTextPair[] = [
  {
    text: 'N標', value: 'SPRule',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => value == 0 ? '' : value
  },
  { text: 'ATC', value: 'ATC' },
  { text: '院內碼', value: 'RxCode' },
  { text: '健保碼', value: 'StdCode' },
  { text: '產品名', value: 'ProdName' },
  { text: '中文名', value: 'ChineseName' },
  {
    text: '成分名', value: 'IIName',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.IIName ?? ''
  },
  {
    text: '通用名', value: 'GXName',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.GXName ?? ''
  },
  {
    text: '劑量', value: 'Potion',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.Potion ?? ''
  },

  { text: '次量', value: 'Dose' },
  { text: '日量', value: 'DailyDose' },
  { text: '總量', value: 'TotalDose' },

  { text: '頻率', value: 'Freq' },
  {
    text: '頻率名', value: 'FreqName',
    // 沒有freqName這個欄位，value會是空直，要從hrx抓
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Options.dosage.find(x => x.Code == hrx.Freq)?.Name || hrx.Freq
  },
  { text: '日份', value: 'Days' },
  { text: '途徑', value: 'Way' },
  {
    text: '途徑名', value: 'WayName',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Options.way.find(x => x.Code == hrx.Way)?.Name || hrx.Way
  },

  {
    text: '單位', value: 'Unit',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => hrx.Unit ? hrx.Unit : (new CheckRx().getHrxIsA1(a, hrx)) ? '' : hrx.BoxUnit
  }, // 如果是瓶裝藥計算 getHrxIsA1 則單位不能換
  {
    text: '單位(總量)', value: 'BoxUnit',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => hrx.BoxUnit ? hrx.BoxUnit : (new CheckRx().getHrxIsA1(a, hrx)) ? '' : hrx.Unit
  }, // 如果是瓶裝藥計算 getHrxIsA1 則單位不能換
  { text: '備註', value: 'Remark' },

  {
    text: '副作用', value: 'SideEffects',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.SideEffects ?? ''
  },
  {
    text: '適應症', value: 'Indications',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.Indications ?? ''
  },
  {
    text: '其他指示', value: 'OtherInstructions',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.OtherInstructions ?? ''
  },
  {
    text: '臨床用途', value: 'ClinicalWay',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.ClinicalWay ?? ''
  },
  {
    text: '外觀', value: 'Exterior',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.Exterior ?? ''
  },
  {
    text: '警語', value: 'Warnings',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.Warnings ?? ''
  },
  {
    text: '重要資訊', value: 'ImportantTip',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.ImportantTip ?? ''
  },
  {
    text: '保存方式', value: 'StorageMethod',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.StorageMethod ?? ''
  },
  {
    text: '效期', value: 'ValidityPeriod',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.ValidityPeriod ?? ''
  },
  {
    text: '製造商', value: 'ManufacturerName',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => a.Rx.find(x => x.RxCode == hrx.RxCode)?.ManufacturerName ?? ''
  },

  { text: '健保價', value: 'IPrice' },
  { text: '自費價', value: 'Price' },
  {
    text: '自費總額', value: 'OwnTotal',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => {
    const price = Number(hrx.Price ?? 0);
    const totalDose = Number(hrx.TotalDose ?? 0);

    return hrx.SPRule == 2 && price > 0
      ? Math.round(totalDose * price)
      : 1;
    }
  },
  { text: '點數', value: 'Tot' },
  { text: '差額', value: 'DiffPrice' },
  { text: '加成', value: 'Plus' },
  { text: '牙位', value: 'ToothPos' },
  { text: '藥品批號', value: 'LotNo' },
  { text: '支付類別', value: 'PaymentType' },
  { text: '調劑', value: 'DispTP' },
  { text: '歸屬', value: 'RxType' },
  { text: '排序', value: 'Sort' },
  {
    text: '流水號', value: 'Seqno',
    extension: (a: ReceiptData, value: any, hrx: HistOrder, seq: number) => seq + 1
  },
  {
    text: '特殊服法(早)', value: 'DosageRemarkM',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => new DosageRemarkModel(hrx.DosageRemark).M
  },
  {
    text: '特殊服法(午)', value: 'DosageRemarkA',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => new DosageRemarkModel(hrx.DosageRemark).A
  },
  {
    text: '特殊服法(晚)', value: 'DosageRemarkE',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => new DosageRemarkModel(hrx.DosageRemark).E
  },
  {
    text: '特殊服法(睡)', value: 'DosageRemarkN',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => new DosageRemarkModel(hrx.DosageRemark).N
  },
  {
    text: '特殊服法(預設文字)', value: 'DosageRemarkDisplay',
    extension: (a: ReceiptData, value: any, hrx: HistOrder) => new DosageRemarkModel(hrx.DosageRemark).toString()
  },
  //   {text:'',value:'Dept'},
  //   {text:'',value:'MedIDName'},
  //   {text:'',value:'BeginDate'},
  //   {text:'',value:'EndDate'},
  //   {text:'',value:'SDate'},
  //   {text:'',value:'STime'},
  //   {text:'',value:'EDate'},
  //   {text:'',value:'ETime'},

  //   {text:'',value:'TransOri'}, // 委託或受託機構代號 (p24)

]
export var ReceiptDataSourceDrugBag: ValueTextPair[] = [
  { text: '袋數', value: 'Bag' },
  { text: '總袋數', value: 'TotalBag' },
  { text: '藥品種類數', value: 'DrugCount' },
  { text: '下次回診日', value: 'NextRegDate' },
  { text: '下次領藥日', value: 'NextDrugDate' }
]

export var ReceiptDataSourceChiReceiptInfo: ValueTextPair[] = [
  { text: '包/天', value: 'FreqQTY' },
  { text: '頻率', value: 'Freq' },
  {
    text: '頻率名', value: 'FreqName',
    // 沒有freqName這個欄位，value會是空值，要從dosage抓
    extension: (a: ReceiptData, value: any) => a.Options.dosage.find(x => x.Code?.trim() == a.ChiReceiptInfo.Freq)?.Name?.trim() ?? a.ChiReceiptInfo.Freq
  },
  { text: '天數', value: 'Days' },
  { text: '天量', value: 'DailyDose' },
  { text: '總包', value: 'TotalPackage' },
  { text: '服法', value: 'Way' },
  { text: '處理備註', value: 'ChiRemark' },
  { text: '處方頁籤', value: 'RxClass' },
  { text: '總量', value: 'TotalDose' },
  { text: '量/包', value: 'QuantityPerPackage' },
  { text: '診察醫令費用', value: 'ConsultationOrderFee' },
  { text: '科學中藥費用', value: 'ScientificChineseMedicineFee' },
  { text: '水藥費用', value: 'WaterMedicineFee' },
  { text: '外用藥費用', value: 'ExternalDrugFee' },
  { text: '注射藥費用', value: 'InjectionDrugFee' },
  { text: '注射技術費用', value: 'InjectionServiceFee' },
  { text: '檢驗費用', value: 'LabFee' },
  { text: '針灸醫令費用', value: 'AcupunctureOrderFee' },
  { text: '傷科醫令費用', value: 'TraumatologyOrderFee' },
  { text: '脫臼醫令費用', value: 'DislocationOrderFee' },
  { text: '手術費用', value: 'SurgeryFee' },
  { text: '麻醉費用', value: 'AnesthesiaFee' },
  { text: '特材費用', value: 'SpecialMaterialFee' },
  { text: '輸血費用', value: 'BloodPlasmaFee' },
  { text: '透析費用', value: 'HemodialysisFee' },
  { text: '病房費用', value: 'CareFee' },
  { text: '管灌費用', value: 'TubeFeedingFee' },
  { text: '嬰兒費用', value: 'BabyFee' },
  { text: '精神治療費用', value: 'PsychiatryTreatmentFee' },
  { text: '代辦費用', value: 'ChargeFee' },
  { text: '藥事服務費用', value: 'MedicineServiceFee' },
  { text: '特殊', value: 'OwnSpecialFee' },
  { text: '醫令費用小計', value: 'TotalOrderFee' },
]

export var ReceiptDataSourceVitalSign: ValueTextPair[] = [
  { text: '身高', value: 'Height' },
  { text: '體重', value: 'Weight' },
  { text: '體溫', value: 'BT' },
  { text: '心跳', value: 'Pulse' },
  { text: '收縮壓', value: 'SBP' },
  { text: '舒張壓', value: 'DBP' },
  { text: '最後來經', value: 'LMPDate' },
  { text: '預產日', value: 'DueDate' },
  //IsPregnant: boolean;
]


export var ReceiptDataSourceType: ValueTextPair[] = [
  { text: '診所', value: 'Clinic', extension: ReceiptDataSourceClinic },
  { text: '病患', value: 'Patient', extension: ReceiptDataSourcePatient },
  { text: '掛號', value: 'Register', extension: ReceiptDataSourceRegister },
  { text: '病歷', value: 'Hist', extension: ReceiptDataSourceHist },
  { text: '生理量測', value: 'VitalSign', extension: ReceiptDataSourceVitalSign },
  { text: '自費', value: 'Fee', extension: ReceiptDataSourceFee },
  { text: '醫令', value: 'HRx', extension: ReceiptDataSourceHRx },
  { text: '藥袋', value: 'DrugBag', extension: ReceiptDataSourceDrugBag },
  { text: '中醫收據', value: 'ChiReceiptInfo', extension: ReceiptDataSourceChiReceiptInfo }
]
export class CheckRx {
  getHrxIsA1(a: ReceiptData, hrx: HistOrder) {
    var rx = a.Rx.find(x => x.RxCode == hrx.RxCode);
    if ((rx?.IsByOral || hrx.RxType == 2) && rx.SpecAmount) {
      return true;
    }
    else return false;
  }
}
export class ReceiptData {
  Clinic: Clinic;
  Patient: WholeHistPatientsDto;
  Register: WholeHistRegisterDto;
  Hist: Hist;
  Hspids: Hspid[] = [];
  VitalSign: VitalSign;
  NHIRegIC: NHIRegIC;
  Fee: ReceiptOwnFees;
  Rx: Rx[];
  PRN001: PRN001Params;
  DrugBag: {
    /** 袋數 */
    Bag: number;
    /** 總袋數 */
    TotalBag: number;
    /** 下次回診日 */
    NextRegDate: string;
    /** 下次領藥日 */
    NextDrugDate: string;
    /** 藥袋藥品總類數量 */
    DrugCount: number;
  }

  ChiReceiptInfo: {
    /** 包/天 */
    FreqQTY: number;

    Freq : string;

    RxClass: string;

    Way: string;

    ChiRemark: string;

    ConsultationOrderFee: number;

    ScientificChineseMedicineFee: number;

    WaterMedicineFee: number;

    ExternalDrugFee: number;

    InjectionDrugFee: number;

    InjectionServiceFee: number;

    LabFee: number;

    AcupunctureOrderFee: number;

    TraumatologyOrderFee: number;

    DislocationOrderFee: number;

    SurgeryFee: number;

    AnesthesiaFee: number;

    SpecialMaterialFee: number;

    BloodPlasmaFee: number;

    HemodialysisFee: number;

    CareFee: number;

    TubeFeedingFee: number;

    BabyFee: number;

    PsychiatryTreatmentFee: number;

    ChargeFee: number;

    MedicineServiceFee: number;

    OwnSpecialFee: number;

    TotalOrderFee: number;

    /**天數 */
    Days: number;

    DailyDose: number;

    TotalDose: number;

    QuantityPerPackage: number;

    TotalPackage: number;
  }

  hrxesOrig: HistOrder[];
  /**
   *
   */
  constructor(info: ReceiptInfoDto, p1: PRN001Params,
    public Options: HistEditOption,
    public regOptions: RegistEditOpt, param?: CmsReportAdditionalParamter) {
    this.Clinic = UserCache.getLoginUser().Clinic;
    this.Patient = info.WholeHist.Patient;
    this.Register = info.WholeHist.Register;

    // clone
    this.Hist = Object.assign({}, info.WholeHist.Hist);
    this.hrxesOrig = info.WholeHist.Hist.HRxs;
    this.Hist.HRxs = [...this.hrxesOrig];

    this.VitalSign = info.WholeHist.VitalSign;
    this.NHIRegIC = info.NHIRegIC;
    this.Fee = new ReceiptOwnFees(info.WholeHist)
    this.Rx = info.Rx;
    this.PRN001 = p1;

    var drugbag = param?.drugBagInfo;
    this.DrugBag = {
      TotalBag: drugbag?.Hrx[0]?.totalPages ?? 0,//防呆，無藥品可列印
      Bag: drugbag?.BagNo ?? 1,
      NextDrugDate: '',
      NextRegDate: '',
      DrugCount: drugbag?.Hrx[0]?.data.length ?? 0//防呆，無藥品可列印
    }
    // 有傳藥袋資料就把醫令過濾掉
    if (drugbag) {
      // SERVER端算完 有回診日則印 不須印的時候會NULL
      if (drugbag.BackDate) {
        this.DrugBag.NextRegDate = DateHelper.formatROCDate(drugbag.BackDate, true, false);
      }
      // SERVER端只留一筆
      if (drugbag.PresDateStartAndEnds?.length > 0) {
        var nextDrugDateEnd = DateHelper.formatROCDate(drugbag.PresDateStartAndEnds[0].EndDate, true, false);
        var nextDrugDateStart = DateHelper.formatROCDate(drugbag.PresDateStartAndEnds[0].StartDate, true, false);
        this.DrugBag.NextDrugDate = nextDrugDateStart + '～' + nextDrugDateEnd;
      }

      this.Hist.HRxs = this.Hist.HRxs.filter(x => drugbag?.Hrx[0]?.data.some(y => y.HRxId == x.Id))
      this.hrxesOrig = [...this.Hist.HRxs];
    }

    var chineseReceiptInfo = param?.chineseReceiptInfo;

    if (chineseReceiptInfo) {
      const hrxIds = new Set(chineseReceiptInfo.chineseRxList.map(b => b.HRxId));
      this.Hist.HRxs = this.Hist.HRxs.filter(x => hrxIds.has(x.Id));
      this.hrxesOrig = [...this.Hist.HRxs];
      const medHrx = chineseReceiptInfo?.chineseRxList.filter(x => [2, 102, 202, 203].includes(x.Rx.Type));
      const firstHrx = medHrx[0];
      console.log(medHrx);
      const totalDailyDose = medHrx.reduce((sum, item) => {
        return sum + (item.DailyDose || 0);
      }, 0);
      const toNumber = (value: any) => isNaN(Number(value)) ? 0 : Number(value);
      const getHrxFeeByPriceTotalDose = (hrx: HistOrder) => {
        const iPrice = toNumber(hrx.IPrice);
        const selfPrice = toNumber(hrx.Price);
        const totalDose = toNumber(hrx.TotalDose);
        const price = selfPrice > 0 && hrx.SPRule == OrderSpecialRuleEnum.A2_SelfPayment ? selfPrice : iPrice;
        return price * totalDose;
      };
      const getFeeByRxTypes = (types: number[]) => this.hrxesOrig.reduce((sum, hrx) => {
        if (!types.includes(hrx.RxType)) {
          return sum;
        }
        return sum + getHrxFeeByPriceTotalDose(hrx);
      }, 0);
      const consultationOrderFee = getFeeByRxTypes([OrderTypeEnum.T1_ConsultationFee]);
      const scientificChineseMedicineFee = getFeeByRxTypes([OrderTypeEnum.T2_OralDrugFee, OrderTypeEnum.T202_DrugSet]);
      const waterMedicineFee = getFeeByRxTypes([OrderTypeEnum.T102_SelfPaymentDrug, OrderTypeEnum.T203_WaterMedicineSet]);
      const externalDrugFee = getFeeByRxTypes([OrderTypeEnum.T3_ExtDrugFee]);
      const injectionDrugFee = getFeeByRxTypes([OrderTypeEnum.T4_InjectionDrugFee]);
      const injectionServiceFee = getFeeByRxTypes([OrderTypeEnum.T5_InjectionServiceFee]);
      const labFee = getFeeByRxTypes([OrderTypeEnum.T6_Lab, OrderTypeEnum.T206_LabSet]);
      const acupunctureOrderFee = getFeeByRxTypes([OrderTypeEnum.T7_XRay, OrderTypeEnum.T407_Acupuncture]);
      const traumatologyOrderFee = getFeeByRxTypes([OrderTypeEnum.T8_RehabilitationFee, OrderTypeEnum.T408_TreatOrPart]);
      const dislocationOrderFee = getFeeByRxTypes([OrderTypeEnum.T9_TreatmentFee, OrderTypeEnum.T409_TreatSlashPart]);
      const surgeryFee = getFeeByRxTypes([OrderTypeEnum.T10_SurgeryFee]);
      const anesthesiaFee = getFeeByRxTypes([OrderTypeEnum.T11_AnesthesiaFee]);
      const specialMaterialFee = getFeeByRxTypes([OrderTypeEnum.T12_SpecialMaterialFee]);
      const bloodPlasmaFee = getFeeByRxTypes([OrderTypeEnum.T13_BloodPlasmaFee]);
      const hemodialysisFee = getFeeByRxTypes([OrderTypeEnum.T14_HemodialysisFee]);
      const careFee = getFeeByRxTypes([OrderTypeEnum.T15_CareFee]);
      const tubeFeedingFee = getFeeByRxTypes([OrderTypeEnum.T16_TubeFeedingFee]);
      const babyFee = getFeeByRxTypes([OrderTypeEnum.T17_BabyFee]);
      const psychiatryTreatmentFee = getFeeByRxTypes([OrderTypeEnum.T18_PsychiatryTreatmentFee]);
      const chargeFee = getFeeByRxTypes([OrderTypeEnum.T19_ChargeFee]);
      const medicineServiceFee = getFeeByRxTypes([OrderTypeEnum.T99_MedicineServiceFee]);
      const ownSpecialFee = getFeeByRxTypes([OrderTypeEnum.T800_OwnSpecial]);
      const totalOrderFee = this.hrxesOrig.reduce((sum, hrx) => sum + getHrxFeeByPriceTotalDose(hrx), 0);



      this.ChiReceiptInfo = {
        FreqQTY: isNaN(Number(firstHrx?.FreqQTY)) ? 0 : Number(firstHrx?.FreqQTY),
        ChiRemark: firstHrx?.ChiRemark,
        Freq : firstHrx?.Freq,
        RxClass: firstHrx?.RxClass,
        Way: firstHrx?.Way,
        ConsultationOrderFee: consultationOrderFee,
        ScientificChineseMedicineFee: scientificChineseMedicineFee,
        WaterMedicineFee: waterMedicineFee,
        ExternalDrugFee: externalDrugFee,
        InjectionDrugFee: injectionDrugFee,
        InjectionServiceFee: injectionServiceFee,
        LabFee: labFee,
        AcupunctureOrderFee: acupunctureOrderFee,
        TraumatologyOrderFee: traumatologyOrderFee,
        DislocationOrderFee: dislocationOrderFee,
        SurgeryFee: surgeryFee,
        AnesthesiaFee: anesthesiaFee,
        SpecialMaterialFee: specialMaterialFee,
        BloodPlasmaFee: bloodPlasmaFee,
        HemodialysisFee: hemodialysisFee,
        CareFee: careFee,
        TubeFeedingFee: tubeFeedingFee,
        BabyFee: babyFee,
        PsychiatryTreatmentFee: psychiatryTreatmentFee,
        ChargeFee: chargeFee,
        MedicineServiceFee: medicineServiceFee,
        OwnSpecialFee: ownSpecialFee,
        TotalOrderFee: totalOrderFee,
        Days: isNaN(Number(firstHrx?.Days)) ? 0 : Number(firstHrx?.Days),
        DailyDose: isNaN(Number(totalDailyDose)) ? 0 : Number(totalDailyDose),
        TotalDose: 0, // 先暫設 0, 下一行會計算
        QuantityPerPackage: 0,
        TotalPackage: 0
      };
      this.ChiReceiptInfo.TotalDose = isNaN(this.ChiReceiptInfo.Days * this.ChiReceiptInfo.DailyDose) ? 0 : this.ChiReceiptInfo.Days * this.ChiReceiptInfo.DailyDose;
      this.ChiReceiptInfo.TotalPackage = isNaN(this.ChiReceiptInfo.Days * this.ChiReceiptInfo.FreqQTY) ? 0 : this.ChiReceiptInfo.Days * this.ChiReceiptInfo.FreqQTY;

      const value = isNaN(this.ChiReceiptInfo.TotalDose / this.ChiReceiptInfo.TotalPackage) ? 0 : this.ChiReceiptInfo.TotalDose / this.ChiReceiptInfo.TotalPackage;

      // 使用 Math.round 方式（回傳 number）
      const rounded = Math.round(value * 10) / 10;
      // 若要字串並且保留一位小數（即使是 .0），可用 toFixed
      const roundedNum = parseFloat(rounded.toFixed(1));

      this.ChiReceiptInfo.QuantityPerPackage = isNaN(roundedNum) ? 0 : roundedNum;
      console.log(this.ChiReceiptInfo);

    }

    // 慢箋非最後一次會印下次領藥日期，最後一次才印下次回診日

  }
  /** 套用醫令規則，無規則就使用原始集合 */
  applyHrxRule(rules: CmsHrxRule[]) {
    console.log('into applyHrxRule >>>>>');
    if (!rules?.length) {
      return;
    }
    this.Hist.HRxs = [...this.hrxesOrig];



    for (let rule of rules) {
      var val = rule.values.split(',').map(v => v.trim());

      this.Hist.HRxs = this.Hist.HRxs.filter(hrx => {
        let fieldValue = '';

        // 檢查是否需要使用 extension 函數
        var fieldDefine = ReceiptDataSourceHRx.find(x => x.value == rule.field);
        if (fieldDefine?.extension) {
          // 使用 extension 函數取值
          fieldValue = fieldDefine.extension(this, hrx[rule.field], hrx)?.toString() ?? '';
        } else {
          // 直接從 HistOrder 物件取值
          fieldValue = hrx[rule.field]?.toString() ?? '';
        }

        console.log(`檢查 ${hrx.RxCode}: ${rule.field} = '${fieldValue}', 規則值: [${rule.values}]`);

        switch (rule.rule) {
          case 'in':
            return val.some(y => y === fieldValue);
          case 'notin':
            return !val.some(y => y === fieldValue);
          default:
            return true;
        }
      });
    }

    console.log(`排除後剩餘醫令數量: ${this.Hist.HRxs.length}`);
  }
  checkReplace(rules: CmsReplaceRule[]) {
    console.log('into checkReplace >>>>>');
    if (!rules?.length) {
      return '';
    }

    for (let rule of rules) {
      var val = rule.values.split(',').map(v => v.trim());
      var d = this.getData(rule.source, rule.field);
      var isMatch = false;
      switch (rule.rule) {
        case 'eq':
          isMatch = d === rule.values.trim();
          break;
        case 'neq':
          isMatch = d !== rule.values.trim();
          break;
        case 'in':
          isMatch = val.some(y => y === d);
          break;
        case 'notin':
          isMatch = !val.some(y => y === d);
          break;
      }
      if (isMatch) {
        console.log(`替代報表條件符合${rule.source}.${rule.field}為"${d}" ${rule.rule} (${rule.values})中 改用報表 ${rule.target}`);
        return rule.target;
      }
    }
    return '';
  }
  getHrx() {
    return this.Hist.HRxs;
  }
  getData(type: string, field: string) {
    var sourceObj = this[type];
    if (!sourceObj) {
      return '';
    }
    var value = sourceObj[field];

    var fieldDefines: ValueTextPair[] = ReceiptDataSourceType.find(x => x.value == type)?.extension
    var modifier = fieldDefines?.find(x => x.value == field)?.extension
    if (modifier) {
      value = modifier(this, value);
    }

    return value;
  }
  getHrxData(i: number, field: string) {
    var sourceObj = this.Hist.HRxs[i];
    var value = sourceObj[field];

    var modifier = ReceiptDataSourceHRx?.find(x => x.value == field)?.extension;
    if (modifier) {
      if (field == 'ToothPos') {
        // 將值轉為字串，並每兩個字插入一個逗號
        if (value !== null && value !== undefined) {
          const s = String(value);
          value = s.replace(/(.{2})/g, '$1,').replace(/,$/, '');
        }
      } else {
        value = modifier(this, value, sourceObj, i);
      }
    }
    return value;
  }
}
